var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.componentClasses,on:{"click":function($event){return _vm.clicked()}}},[_c('svg',{attrs:{"width":"28","height":"28","viewBox":"0 0 28 28","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M4 18H0V28H10V24H4V18ZM0 10H4V4H10V0H0V10ZM24 24H18V28H28V18H24V24ZM18 0V4H24V10H28V0H18Z","fill":"black"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }